export enum QuestionnairePageType {
  new = 'new',
  answers = 'answers',
  scores = 'scores',
  pgNew = 'pgNew',
  pgScores = 'pgScores'
}
